import create from './createAction'

export const GET_TEAMS_BY_CODE = 'GET_TEAMS_BY_CODE'
export const SET_TEAMS_BY_CODE = 'SET_TEAMS_BY_CODE'
export const GET_TEAMS_BY_USER = 'GET_TEAMS_BY_USER'
export const SET_TEAMS_BY_USER = 'SET_TEAMS_BY_USER'
export const GET_ALL_TEAM_CODES = 'GET_ALL_TEAM_CODES'
export const SET_ALL_TEAM_CODES = 'SET_ALL_TEAM_CODES'
export const SET_TEAM_FORM_TYPE = 'SET_TEAM_FORM_TYPE'
export const SEND_EMAIL_TEAM_REGO = 'SEND_EMAIL_TEAM_REGO'
export const GET_TEAMS_IN_EVENT = 'GET_TEAMS_IN_EVENT'
export const SET_TEAMS_IN_EVENT = 'SET_TEAMS_IN_EVENT'
export const GET_TEAM_LOGO = 'GET_TEAM_LOGO'
export const SET_TEAM_LOGO = 'SET_CURRENT_TEAM_LOGO'

export const getTeamsByCode = create(GET_TEAMS_BY_CODE)
export const setTeamsByCode = create(SET_TEAMS_BY_CODE)
export const getTeamsByUser = create(GET_TEAMS_BY_USER)
export const setTeamsByUser = create(SET_TEAMS_BY_USER)
export const getAllTeamCodes = create(GET_ALL_TEAM_CODES)
export const setAllTeamCodes = create(SET_ALL_TEAM_CODES)
export const setTeamFormType = create(SET_TEAM_FORM_TYPE)
export const sendEmailTeamRego = create(SEND_EMAIL_TEAM_REGO)
export const getTeamsInEvent = create(GET_TEAMS_IN_EVENT)
export const setTeamsInEvent = create(SET_TEAMS_IN_EVENT)
export const getTeamLogo = create(GET_TEAM_LOGO)
export const setTeamLogo = create(SET_TEAM_LOGO)
